/**
 * filename: AllRowsSelector.jsx
 * date: 2018-10-06
 * author: Tony Garcia
 * description: widget that allows user to select/clear rows from all pages of a grid
 */

import numeral from "numeral";
import { FC } from "react";

type Props = {
  allRowsSelected: boolean;
  totalResults: number;
  selected: Array<unknown>;
  onSelectAllRowsChange: () => void;
  onDeSelectAllRowsChange?: () => void;
  positionAboveGrid?: boolean;
  entityName?: string;
};

const AllRowsSelector: FC<Props> = ({
  allRowsSelected,
  totalResults,
  selected,
  onSelectAllRowsChange,
  onDeSelectAllRowsChange,
  positionAboveGrid,
  entityName = "sample"
}) => (
  <div style={{ position: "relative" }}>
    <span
      className="selection-message"
      style={{ zIndex: 20, top: positionAboveGrid ? "-50px" : "6px" }}
    >
      {allRowsSelected && (
        <span
          className="samples-grid__underline-link"
          onClick={onDeSelectAllRowsChange ?? onSelectAllRowsChange}
        >
          {totalResults === 1
            ? `Deselect 1 ${entityName}.`
            : `Deselect all ${numeral(totalResults).format(
                "0,0"
              )} ${entityName}s.`}
        </span>
      )}
      {!allRowsSelected && (
        <>
          {numeral(selected.length).format("0,0")} row
          {selected.length === 1 ? "" : "s"} selected.{" "}
          {
            <span
              className="samples-grid__underline-link"
              onClick={onSelectAllRowsChange}
            >
              {totalResults === 1
                ? `Select 1 ${entityName}.`
                : `Select all ${numeral(totalResults).format(
                    "0,0"
                  )} ${entityName}s.`}
            </span>
          }
        </>
      )}
    </span>
  </div>
);

export default AllRowsSelector;
